import * as api from '../api/index'

import {
  ADD_NEW_SHIPPING,
  UPDATE_SHIPPING,
  DELETE_SHIPPING,
  FETCH_SHIPPINGS_BY_USER,
  FETCH_SHIPPING,
  START_LOADING,
  END_LOADING,
  ALL_SHIPPINGS,
} from './constants'

export const getShipping = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING })
    const { data } = await api.fetchShipping()
    dispatch({ type: FETCH_SHIPPING, payload: { shipping: data } })
  } catch (error) {
    console.log(error)
  }
}

export const getShippingsByUser = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING })
    const { data } = await api.fetchShippingsByUser(searchQuery)
    dispatch({ type: FETCH_SHIPPINGS_BY_USER, payload: data.results })
    dispatch({ type: END_LOADING })
  } catch (error) {
    console.log(error.response)
  }
}

export const getAllShippings = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING })
    const { data } = await api.fetchShippings()
    dispatch({ type: ALL_SHIPPINGS, payload: data.results })
    dispatch({ type: END_LOADING })
  } catch (error) {
    console.log(error.response)
  }
}

export const createShipping = (shipping, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.addShipping(shipping)
    dispatch({ type: ADD_NEW_SHIPPING, payload: data.data })
    openSnackbar('Shipping added successfully')
  } catch (error) {
    console.log(error)
  }
}

export const updateShipping = (id, shipping, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateShipping(id, shipping)
    dispatch({ type: UPDATE_SHIPPING, payload: data.data })
    openSnackbar('Shipping updated successfully')
  } catch (error) {
    console.log(error)
  }
}

export const deleteShipping = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteShipping(id)
    dispatch({ type: DELETE_SHIPPING, payload: id })
    openSnackbar('Shipping deleted successfully')
  } catch (error) {
    console.log(error)
  }
}
